(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('swifRouteService', swifRouteService);

    /**
        * @ngdoc service
        * @name swif.framework.swifRouteService
        * @requires swif.framework.settingsService
        * @requires swif.framework.userService
        * @requires swif.framework.swifResourcesService
    **/
    function swifRouteService(
        $q,
        $location,
        swifMomentUtility,
        settingsService,
        userService,
        swifResourcesService
    ) {
        'ngInject';
        var settings = settingsService;
        var resources = swifResourcesService;
        var service = {};
        service.q = $q;
        service.debug = $location.search().debug || false;
        service.settings = settings;
        service.user = userService;
        service.resources = resources;
        service.initializedAndAuthenticated = function () {
            return settings.initialize().then(function () {
                return userService.getSessionInfo();
            });
        };

        /**
             * @ngdoc method
             * @name check
             * @methodOf swif.framework.swifRouteService
             * @param {Object} options {public: false, resources: ['d3', 'fullcalendar']}
             * @returns {Promise} true
             * @description
             * Check if the needed conditions are loaded for a given route This function return a Boolean throw
             * a Promise or reject if the needed conditions are not met.
             * @usage
            return swifRouteService.check().then(function () {
                var deferred = $q.defer();
                var data = {};
                data.debug = swif.route.debug;
                data.title = 'Requests';
                deferred.resolve(data);
                return deferred.promise;
            });
        **/
        service.check = function (options) {
            if (options === undefined) {
                options = {};
            }
            function onError(error) {
                if (_.get(settings, ['app', 'features', 'providersProfile'], false) !== true) {
                    $location.search('next', $location.path());
                }
                $location.path('/logout');
                deferred.reject(error);
            }
            var deferred = $q.defer();
            settings.initialize().then(function () {
                var promises = [];
                if (!options.public) {
                    //redirect if not loggedin
                    promises.push(userService.getSessionInfo());
                }
                if (options.resources) {
                    promises.push(resources.add(options.resources));
                }
                $q.all(promises).then(function (results) {
                    if (!options.public) {
                        var session = results[0];
                        if (session) {
                            if (session.uid === false) {
                                //$location.search('next', $location.path());
                                //$location.path('/logout');
                                deferred.reject('SESSION INVALID');
                            } else {
                                //loggedin
                                userService.redirectIfWrongDB();
                                if (!userService.getAuthenticatedUserData()) {
                                    onError();
                                    return;
                                }
                                if (!swifMomentUtility.initialized) {
                                    swifMomentUtility.load_special_days();
                                }
                                deferred.resolve(true);
                            }
                        } else {
                            deferred.reject('NO SESSION');
                        }
                    } else {
                        deferred.resolve(true);
                    }
                }, onError);
            });
            return deferred.promise;
        };

        return service;
    }

})();
